import React from 'react';
import styled from 'styled-components';

const Layout = styled.div`
  width: 100%;
  max-width: ${props => props.theme.containerMaxW/10}em;
  margin: auto;
  
  &.use-cyrillic-font {
    * {
      font-family: Flow-Cyrillic;
    }
      &:not(.dingbats):not(.typography-logo):not(.logo-type) {
        
      }
   
  }
`;

interface Props {
  children?: React.ReactNode;
  className?: string;
}

const AppLayout = ({
  children,
  className
}: Props) => {
  return (
    <Layout className={className}>
      {children}
    </Layout>
  )
};

export default AppLayout;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/layouts/AppLayout.tsx